import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-22ff6ea9")

_pushScopeId("data-v-22ff6ea9")
const _hoisted_1 = { class: "toc_ui__reminder_main" }
const _hoisted_2 = { class: "toc_ui__reminder_body" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "toc_ui__reminder_title" }, " 温馨提示 ", -1)
const _hoisted_4 = {
  key: 0,
  class: "toc_ui__reminder_cnt"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("span", null, "1.⻋辆信息仅供参考，实际⻋型与配置信息请以实⻋为准，此证书⼿写无效；", -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("span", null, "2.车辆基本照片仅供参考，实际车辆状况以售卖车辆为准；", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode("3.")
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("天收购保障，须具备268V检测保障承诺书，单独出具此检测评估报告不具备法律效⼒；")
const _hoisted_13 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_14 = { key: 0 }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("4.经268V买车无忧检测+质保双准入的车辆，车况即符合268V买车无忧保准入条件，经采购付费，可享有“最低一年3万公里”质保服务（精选保障plus产品可享一年不限公里保修） ，具体保修范围、最高赔付限额、保修期限（年限及公里数限制）等以实际购买产品为准。")
const _hoisted_16 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_17 = {
  key: 1,
  class: "toc_ui__reminder_cnt"
}
const _hoisted_18 = /*#__PURE__*/_createVNode("span", null, "1.⻋辆信息仅供参考，实际⻋型与配置信息请以实⻋为准，此证书⼿写无效；", -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("span", null, "2.车辆基本照片仅供参考，实际车辆状况以售卖车辆为准；", -1)
const _hoisted_21 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("span", null, "3.268V检测标准符合国家二手车鉴定标准和CADA团体标准，且本公司获ISO 9001质量管理体系认证，如对检测标准有异议，或您需要对检测报告进行解读，请拨打400-808-3718咨询。", -1)
const _hoisted_23 = {
  key: 2,
  class: "toc_ui__reminder_cnt"
}
const _hoisted_24 = /*#__PURE__*/_createVNode("span", null, "1.⻋辆信息仅供参考，实际⻋型与配置信息请以实⻋为准，此证书⼿写无效；", -1)
const _hoisted_25 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_26 = /*#__PURE__*/_createVNode("span", null, "2.车辆基本照片仅供参考，实际车辆状况以售卖车辆为准；", -1)
const _hoisted_27 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_28 = /*#__PURE__*/_createVNode("span", null, "3.本报告检测内容仅供参考，不可直接作为车辆交易凭证，如您参考此报告购车，268V不承担任何检测失误责任；", -1)
const _hoisted_29 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_30 = /*#__PURE__*/_createVNode("span", null, "4.268V检测标准符合国家二手车鉴定标准和CADA团体标准，且本公司获ISO 9001质量管理体系认证，如对检测标准有异议，或您需要对检测报告进行解读，请拨打400-808-3718咨询。", -1)
const _hoisted_31 = {
  key: 3,
  class: "toc_ui__reminder_cnt"
}
const _hoisted_32 = /*#__PURE__*/_createVNode("span", null, "1.⻋辆信息仅供参考，实际⻋型与配置信息请以实⻋为准，此证书⼿写无效；", -1)
const _hoisted_33 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_34 = /*#__PURE__*/_createVNode("span", null, "2.除事故检测、泡水检测、火烧检测、发动机、变速箱外，其余检测项目结果仅反映检测当下的车辆状况，报告信息仅供参考，实际车辆状况以售卖车辆为准；", -1)
const _hoisted_35 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_36 = /*#__PURE__*/_createVNode("span", null, "3.车辆基本照片仅供参考，实际车辆状况以售卖车辆为准；", -1)
const _hoisted_37 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_38 = /*#__PURE__*/_createTextVNode("4.")
const _hoisted_39 = { key: 0 }
const _hoisted_40 = { key: 1 }
const _hoisted_41 = /*#__PURE__*/_createTextVNode("天收购保障，须具备268V检测保障承诺书，单独出具此检测评估报告不具备法律效⼒；")
const _hoisted_42 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_43 = /*#__PURE__*/_createVNode("span", null, "5.268V检测标准符合国家二手车鉴定标准和CADA团体标准，且本公司获ISO 9001质量管理体系认证，如对检测标准有异议，或您需要对检测报告进行解读，请拨打400-808-3718咨询。", -1)
const _hoisted_44 = { class: "toc_ui__reminder_body" }
const _hoisted_45 = /*#__PURE__*/_createVNode("div", { class: "toc_ui__reminder_title" }, " 温馨提示 ", -1)
const _hoisted_46 = {
  key: 0,
  class: "toc_ui__reminder_cnt"
}
const _hoisted_47 = /*#__PURE__*/_createStaticVNode("<span data-v-22ff6ea9>1.车辆基本信息仅供参考，实际车型与配置信息以实车为准，此证书手写无效；</span><br data-v-22ff6ea9><span data-v-22ff6ea9>2.车辆基本照片仅供参考，实际车辆状况以售卖车辆为准；</span><br data-v-22ff6ea9><span data-v-22ff6ea9>3.“表显里程”是检测人员依据所检测车辆里程表显示的数据填写的，该信息仅供参考，表显里程数不在我们的车辆检测承保范围内。</span><br data-v-22ff6ea9><span data-v-22ff6ea9>4.对指定车辆进行不解体静态检测，即车辆处于原地静止状态检测，仅限原地着车检测，不包含车辆动态行驶性能检测；<br data-v-22ff6ea9></span><span data-v-22ff6ea9>5.根据检测需要仅对车辆辅件、内饰进行拆解，不对车辆加强件、结构件做深度拆解；<br data-v-22ff6ea9></span><span data-v-22ff6ea9>6.90天收购保障，须具备268V检测保障承诺书，单独出具此检测评估报告不具备法律效力；<br data-v-22ff6ea9></span><span data-v-22ff6ea9>7.268V检测标准符合国家二手车鉴定标准和CADA团体标准，且本公司获ISO 9001质量管理体系认证，如对检测标准有异议，或您需要对检测报告进行解读，请拨打400-808-3718咨询。</span>", 10)
const _hoisted_57 = {
  key: 1,
  class: "toc_ui__reminder_cnt"
}
const _hoisted_58 = /*#__PURE__*/_createVNode("span", null, "1.⻋辆信息仅供参考，实际⻋型与配置信息请以实⻋为准，此证书⼿写⽆效；", -1)
const _hoisted_59 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_60 = /*#__PURE__*/_createVNode("span", null, "2.⻋辆基本照⽚仅供参考，实际⻋辆状况以售卖⻋辆为准；", -1)
const _hoisted_61 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_62 = /*#__PURE__*/_createVNode("span", null, "3.对指定车辆进行不解体静态检测，即车辆处于原地静止状态检测，仅限原地着车检测，不包含车辆动态行驶性能检测；", -1)
const _hoisted_63 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_64 = /*#__PURE__*/_createVNode("span", null, "4.90天收购保障，须具备268V检测保障承诺书，单独出具此检测评估报告不具备法律效⼒；", -1)
const _hoisted_65 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_66 = /*#__PURE__*/_createVNode("span", null, "5.经268V买⻋⽆忧检测+质保双准⼊的⻋辆，⻋况即符合268V买⻋⽆忧保准⼊条件，经采购付费，可享有“最低⼀年3万公⾥”质保服务（精选保障plus产品可享⼀年不限公⾥保修） ，具体保修范围、最⾼赔付限额、保修期限（年限及公⾥数限制）等以实际购买产品为准。", -1)
const _hoisted_67 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_68 = /*#__PURE__*/_createVNode("span", null, "6.268V检测标准符合国家⼆⼿⻋鉴定标准和CADA团体标准，且本公司获ISO 9001质量管理体系认证，如对检测标准有异议，或您需要对检测报告进⾏解读，请拨打400-808-3718咨询。", -1)
const _hoisted_69 = {
  key: 2,
  class: "toc_ui__reminder_cnt"
}
const _hoisted_70 = /*#__PURE__*/_createVNode("span", null, "1.车辆信息仅供参考，实际车型与配置信息请以实车为准，此证书手写无效；", -1)
const _hoisted_71 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_72 = /*#__PURE__*/_createVNode("span", null, "2.车辆基本照片仅供参考，实际车辆状况以售卖车辆为准；", -1)
const _hoisted_73 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_74 = /*#__PURE__*/_createVNode("span", null, "3.对指定车辆进行不解体静态检测，即车辆处于原地静止状态检测，仅限原地着车检测，不包含车辆动态行驶性能检测；", -1)
const _hoisted_75 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_76 = /*#__PURE__*/_createVNode("span", null, "4.本报告检测内容仅供参考，不可直接作为车辆交易凭证，如您参考此报告购车，268V不承担任何检测失误责任；", -1)
const _hoisted_77 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_78 = /*#__PURE__*/_createVNode("span", null, "5.268V检测标准符合国家二手车鉴定标准和CADA团体标准，且本公司获ISO 9001质量管理体系认证，如对检测标准有异议，或您需要对检测报告进行解读，请拨打400-808-3718咨询。", -1)
const _hoisted_79 = {
  key: 3,
  class: "toc_ui__reminder_cnt"
}
const _hoisted_80 = /*#__PURE__*/_createStaticVNode("<span data-v-22ff6ea9>1.车辆基本信息仅供参考，实际车型与配置信息以实车为准，此证书手写无效；</span><br data-v-22ff6ea9><span data-v-22ff6ea9>2.除事故检测、泡水检测、火烧检测、发动机、变速箱外，其余检测项目结果仅反应检测当下的车辆状况，报告信息仅供参考，实际车辆状况以售卖车辆为准；</span><br data-v-22ff6ea9><span data-v-22ff6ea9>3.车辆基本照片仅供参考，实际车辆状况以售卖车辆为准；</span><br data-v-22ff6ea9><span data-v-22ff6ea9>4.“表显里程”是检测人员依据所检测车辆里程表显示的数据填写的，该信息仅供参考，表显里程数不在我们的车辆检测承保范围内。</span><br data-v-22ff6ea9><span data-v-22ff6ea9>5.对指定车辆进行不解体静态检测，即车辆处于原地静止状态检测，仅限原地着车检测，不包含车辆动态行驶性能检测；</span><br data-v-22ff6ea9><span data-v-22ff6ea9>6.根据检测需要仅对车辆辅件、内饰进行拆解，不对车辆加强件、结构件、发动机、变速器做深度拆解；</span><br data-v-22ff6ea9><span data-v-22ff6ea9>7.90天收购保障，须具备268V检测保障承诺书，单独出具此检测评估报告不具备法律效力；</span><br data-v-22ff6ea9><span data-v-22ff6ea9>8.268V检测标准符合国家二手车鉴定标准和CADA团体标准，且本公司获ISO 9001质量管理体系认证，如对检测标准有异议，或您需要对检测报告进行解读，请拨打400-808-3718咨询。</span>", 15)
const _hoisted_95 = {
  key: 0,
  class: "toc_ui__reminder_body"
}
const _hoisted_96 = /*#__PURE__*/_createVNode("div", { class: "toc_ui__reminder_title" }, " 温馨提示 ", -1)
const _hoisted_97 = {
  key: 0,
  class: "toc_ui__reminder_cnt"
}
const _hoisted_98 = /*#__PURE__*/_createStaticVNode("<span data-v-22ff6ea9>1.车辆基本信息仅供参考，实际车型与配置信息以实车为准，此证书手写无效；</span><br data-v-22ff6ea9><span data-v-22ff6ea9>2.车辆基本照片仅供参考，实际车辆状况以售卖车辆为准；</span><br data-v-22ff6ea9><span data-v-22ff6ea9>3.“表显里程”是检测人员依据所检测车辆里程表显示的数据填写的，该信息仅供参考，表显里程数不在我们的车辆检测承保范围内。</span><br data-v-22ff6ea9><span data-v-22ff6ea9>4.对指定车辆进行不解体静态检测，即车辆处于原地静止状态检测，仅限原地着车检测，不包含车辆动态行驶性能检测；<br data-v-22ff6ea9></span><span data-v-22ff6ea9>5.根据检测需要仅对车辆辅件、内饰进行拆解，不对车辆加强件、结构件做深度拆解；<br data-v-22ff6ea9></span><span data-v-22ff6ea9>6.90天交易价回购保障，激活享365天，须具备268V检测保障承诺书，单独出具此检测评估报告不具备法律效力;<br data-v-22ff6ea9></span><span data-v-22ff6ea9>7.268V检测标准符合国家二手车鉴定标准和CADA团体标准，且本公司获ISO 9001质量管理体系认证，如对检测标准有异议，或您需要对检测报告进行解读，请拨打400-808-3718咨询。</span>", 10)
const _hoisted_108 = {
  key: 1,
  class: "toc_ui__reminder_cnt"
}
const _hoisted_109 = /*#__PURE__*/_createStaticVNode("<span data-v-22ff6ea9>1.车辆基本信息仅供参考，实际车型与配置信息以实车为准，此证书手写无效；</span><br data-v-22ff6ea9><span data-v-22ff6ea9>2.车辆基本照片仅供参考，实际车辆状况以售卖车辆为准；</span><br data-v-22ff6ea9><span data-v-22ff6ea9>3.“表显里程”是检测人员依据所检测车辆里程表显示的数据填写的，该信息仅供参考，表显里程数不在我们的车辆检测承保范围内。</span><br data-v-22ff6ea9><span data-v-22ff6ea9>4.对指定车辆进行不解体静态检测，即车辆处于原地静止状态检测，仅限原地着车检测，不包含车辆动态行驶性能检测；<br data-v-22ff6ea9></span><span data-v-22ff6ea9>5.根据检测需要仅对车辆辅件、内饰进行拆解，不对车辆加强件、结构件做深度拆解；<br data-v-22ff6ea9></span><span data-v-22ff6ea9>6.90天错检赔付保障，激活享365天，须具备268V检测保障承诺书，单独出具此检测评估报告不具备法律效力;<br data-v-22ff6ea9></span><span data-v-22ff6ea9>7.268V检测标准符合国家二手车鉴定标准和CADA团体标准，且本公司获ISO 9001质量管理体系认证，如对检测标准有异议，或您需要对检测报告进行解读，请拨打400-808-3718咨询。</span>", 10)
const _hoisted_119 = {
  key: 2,
  class: "toc_ui__reminder_cnt"
}
const _hoisted_120 = /*#__PURE__*/_createVNode("span", null, "1.⻋辆信息仅供参考，实际⻋型与配置信息请以实⻋为准，此证书⼿写⽆效；", -1)
const _hoisted_121 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_122 = /*#__PURE__*/_createVNode("span", null, "2.⻋辆基本照⽚仅供参考，实际⻋辆状况以售卖⻋辆为准；", -1)
const _hoisted_123 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_124 = /*#__PURE__*/_createVNode("span", null, "3.对指定车辆进行不解体静态检测，即车辆处于原地静止状态检测，仅限原地着车检测，不包含车辆动态行驶性能检测；", -1)
const _hoisted_125 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_126 = /*#__PURE__*/_createVNode("span", null, "4.90天交易价回购保障，激活享365天，须具备268V检测保障承诺书，单独出具此检测评估报告不具备法律效力;", -1)
const _hoisted_127 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_128 = /*#__PURE__*/_createVNode("span", null, "5.经268V买⻋⽆忧检测+质保双准⼊的⻋辆，⻋况即符合268V买⻋⽆忧保准⼊条件，经采购付费，可享有“最低⼀年3万公⾥”质保服务（精选保障plus产品可享⼀年不限公⾥保修） ，具体保修范围、最⾼赔付限额、保修期限（年限及公⾥数限制）等以实际购买产品为准。", -1)
const _hoisted_129 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_130 = /*#__PURE__*/_createVNode("span", null, "6.268V检测标准符合国家⼆⼿⻋鉴定标准和CADA团体标准，且本公司获ISO 9001质量管理体系认证，如对检测标准有异议，或您需要对检测报告进⾏解读，请拨打400-808-3718咨询。", -1)
const _hoisted_131 = {
  key: 3,
  class: "toc_ui__reminder_cnt"
}
const _hoisted_132 = /*#__PURE__*/_createVNode("span", null, "1.车辆信息仅供参考，实际车型与配置信息请以实车为准，此证书手写无效；", -1)
const _hoisted_133 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_134 = /*#__PURE__*/_createVNode("span", null, "2.车辆基本照片仅供参考，实际车辆状况以售卖车辆为准；", -1)
const _hoisted_135 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_136 = /*#__PURE__*/_createVNode("span", null, "3.对指定车辆进行不解体静态检测，即车辆处于原地静止状态检测，仅限原地着车检测，不包含车辆动态行驶性能检测；", -1)
const _hoisted_137 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_138 = /*#__PURE__*/_createVNode("span", null, "4.本报告检测内容仅供参考，不可直接作为车辆交易凭证，如您参考此报告购车，268V不承担任何检测失误责任；", -1)
const _hoisted_139 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_140 = /*#__PURE__*/_createVNode("span", null, "5.268V检测标准符合国家二手车鉴定标准和CADA团体标准，且本公司获ISO 9001质量管理体系认证，如对检测标准有异议，或您需要对检测报告进行解读，请拨打400-808-3718咨询。", -1)
const _hoisted_141 = {
  key: 4,
  class: "toc_ui__reminder_cnt"
}
const _hoisted_142 = /*#__PURE__*/_createStaticVNode("<span data-v-22ff6ea9>1.车辆基本信息仅供参考，实际车型与配置信息以实车为准，此证书手写无效；</span><br data-v-22ff6ea9><span data-v-22ff6ea9>2.除事故检测、泡水检测、火烧检测、发动机、变速箱外，其余检测项目结果仅反应检测当下的车辆状况，报告信息仅供参考，实际车辆状况以售卖车辆为准；</span><br data-v-22ff6ea9><span data-v-22ff6ea9>3.车辆基本照片仅供参考，实际车辆状况以售卖车辆为准；</span><br data-v-22ff6ea9><span data-v-22ff6ea9>4.“表显里程”是检测人员依据所检测车辆里程表显示的数据填写的，该信息仅供参考，表显里程数不在我们的车辆检测承保范围内。</span><br data-v-22ff6ea9><span data-v-22ff6ea9>5.对指定车辆进行不解体静态检测，即车辆处于原地静止状态检测，仅限原地着车检测，不包含车辆动态行驶性能检测；</span><br data-v-22ff6ea9><span data-v-22ff6ea9>6.根据检测需要仅对车辆辅件、内饰进行拆解，不对车辆加强件、结构件、发动机、变速器做深度拆解；</span><br data-v-22ff6ea9><span data-v-22ff6ea9>7.90天交易价回购保障，激活享365天，须具备268V检测保障承诺书，单独出具此检测评估报告不具备法律效力;</span><br data-v-22ff6ea9><span data-v-22ff6ea9>8.268V检测标准符合国家二手车鉴定标准和CADA团体标准，且本公司获ISO 9001质量管理体系认证，如对检测标准有异议，或您需要对检测报告进行解读，请拨打400-808-3718咨询。</span>", 15)
const _hoisted_157 = { class: "toc_ui__anti_body" }
const _hoisted_158 = { class: "toc_ui__anti_farkurl" }
const _hoisted_159 = /*#__PURE__*/_createVNode("div", { class: "toc_ui__anti_farklogo" }, null, -1)
const _hoisted_160 = /*#__PURE__*/_createVNode("div", { class: "toc_ui__anti_farktext" }, "识别二维码查看报告真伪", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _withDirectives(_createVNode("div", _hoisted_2, [
      _hoisted_3,
      (((_ctx.state.reportMsg.Rp299() && !_ctx.state.reportMsg.RpJG()) || _ctx.state.reportMsg.RpHC() || _ctx.state.reportMsg.RpSRZ()) && !_ctx.state.reportMsg.RpCK())
        ? (_openBlock(), _createBlock("div", _hoisted_4, [
            _hoisted_5,
            _hoisted_6,
            _hoisted_7,
            _hoisted_8,
            _createVNode("span", null, [
              _hoisted_9,
              (_ctx.state.channelType === 'jiaxuan')
                ? (_openBlock(), _createBlock("span", _hoisted_10, "100"))
                : (_openBlock(), _createBlock("span", _hoisted_11, "90")),
              _hoisted_12
            ]),
            _hoisted_13,
            (_ctx.state.reportMsg.RpSRZ())
              ? (_openBlock(), _createBlock("span", _hoisted_14, [
                  _hoisted_15,
                  _hoisted_16
                ]))
              : _createCommentVNode("", true),
            _createVNode("span", null, _toDisplayString(_ctx.state.reportMsg.RpSRZ() ? '5' : '4') + ".268V检测标准符合国家二手车鉴定标准和CADA团体标准，且本公司获ISO 9001质量管理体系认证，如对检测标准有异议，或您需要对检测报告进行解读，请拨打400-808-3718咨询。", 1)
          ]))
        : (_ctx.state.reportMsg.RpFJ() && !_ctx.state.reportMsg.RpCK())
          ? (_openBlock(), _createBlock("div", _hoisted_17, [
              _hoisted_18,
              _hoisted_19,
              _hoisted_20,
              _hoisted_21,
              _hoisted_22
            ]))
          : (_ctx.state.reportMsg.RpCK())
            ? (_openBlock(), _createBlock("div", _hoisted_23, [
                _hoisted_24,
                _hoisted_25,
                _hoisted_26,
                _hoisted_27,
                _hoisted_28,
                _hoisted_29,
                _hoisted_30
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_31, [
                _hoisted_32,
                _hoisted_33,
                _hoisted_34,
                _hoisted_35,
                _hoisted_36,
                _hoisted_37,
                _createVNode("span", null, [
                  _hoisted_38,
                  (_ctx.state.channelType === 'jiaxuan')
                    ? (_openBlock(), _createBlock("span", _hoisted_39, "100"))
                    : (_openBlock(), _createBlock("span", _hoisted_40, "90")),
                  _hoisted_41
                ]),
                _hoisted_42,
                _hoisted_43
              ]))
    ], 512), [
      [_vShow, _ctx.state.channelType !== 'lingshou' && (!_ctx.state.reportTipVersion || _ctx.state.reportTipVersion < 240326)]
    ]),
    _withDirectives(_createVNode("div", _hoisted_44, [
      _hoisted_45,
      (((_ctx.state.reportMsg.Rp299() && !_ctx.state.reportMsg.RpJG()) || _ctx.state.reportMsg.RpHC()) && !_ctx.state.reportMsg.RpCK() && !_ctx.state.reportMsg.RpSRZ())
        ? (_openBlock(), _createBlock("div", _hoisted_46, [
            _hoisted_47
          ]))
        : _createCommentVNode("", true),
      (_ctx.state.reportMsg.RpSRZ())
        ? (_openBlock(), _createBlock("div", _hoisted_57, [
            _hoisted_58,
            _hoisted_59,
            _hoisted_60,
            _hoisted_61,
            _hoisted_62,
            _hoisted_63,
            _hoisted_64,
            _hoisted_65,
            _hoisted_66,
            _hoisted_67,
            _hoisted_68
          ]))
        : (_ctx.state.reportMsg.RpCK())
          ? (_openBlock(), _createBlock("div", _hoisted_69, [
              _hoisted_70,
              _hoisted_71,
              _hoisted_72,
              _hoisted_73,
              _hoisted_74,
              _hoisted_75,
              _hoisted_76,
              _hoisted_77,
              _hoisted_78
            ]))
          : (_ctx.state.reportMsg.Rp499() || _ctx.state.reportMsg.Rp699() || _ctx.state.reportMsg.Rp799() || _ctx.state.reportMsg.RpRCAUTH() || (_ctx.state.reportMsg.RpJG() && _ctx.state.reportMsg.Rp299()))
            ? (_openBlock(), _createBlock("div", _hoisted_79, [
                _hoisted_80
              ]))
            : _createCommentVNode("", true)
    ], 512), [
      [_vShow, _ctx.state.channelType !== 'lingshou' &&
        ((!_ctx.state.formatOrderDate && _ctx.state.reportTipVersion && _ctx.state.reportTipVersion >= 240326) ||
        (_ctx.state.formatOrderDate && ((_ctx.state.formatOrderDate < _ctx.state.version240702 && _ctx.state.formatOrderDate > _ctx.state.version240326) ||
        _ctx.state.formatOrderDate > _ctx.state.version240704)))]
    ]),
    (_ctx.channelType != "lingshou" && _ctx.state.formatOrderDate && _ctx.state.formatOrderDate >= _ctx.state.version240702 && _ctx.state.formatOrderDate <= _ctx.state.version240704)
      ? (_openBlock(), _createBlock("div", _hoisted_95, [
          _hoisted_96,
          ((_ctx.state.reportMsg.Rp299() && !_ctx.state.reportMsg.RpJG()) && !_ctx.state.reportMsg.RpCK() && !_ctx.state.reportMsg.RpSRZ())
            ? (_openBlock(), _createBlock("div", _hoisted_97, [
                _hoisted_98
              ]))
            : _createCommentVNode("", true),
          (_ctx.state.reportMsg.RpHC())
            ? (_openBlock(), _createBlock("div", _hoisted_108, [
                _hoisted_109
              ]))
            : _createCommentVNode("", true),
          (_ctx.state.reportMsg.RpSRZ())
            ? (_openBlock(), _createBlock("div", _hoisted_119, [
                _hoisted_120,
                _hoisted_121,
                _hoisted_122,
                _hoisted_123,
                _hoisted_124,
                _hoisted_125,
                _hoisted_126,
                _hoisted_127,
                _hoisted_128,
                _hoisted_129,
                _hoisted_130
              ]))
            : (_ctx.state.reportMsg.RpCK())
              ? (_openBlock(), _createBlock("div", _hoisted_131, [
                  _hoisted_132,
                  _hoisted_133,
                  _hoisted_134,
                  _hoisted_135,
                  _hoisted_136,
                  _hoisted_137,
                  _hoisted_138,
                  _hoisted_139,
                  _hoisted_140
                ]))
              : (_ctx.state.reportMsg.Rp499() || _ctx.state.reportMsg.Rp699() || _ctx.state.reportMsg.Rp799() || _ctx.state.reportMsg.RpRCAUTH() || (_ctx.state.reportMsg.RpJG() && _ctx.state.reportMsg.Rp299()))
                ? (_openBlock(), _createBlock("div", _hoisted_141, [
                    _hoisted_142
                  ]))
                : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode("div", _hoisted_157, [
      _createVNode("div", _hoisted_158, [
        _createVNode("img", {
          src: _ctx.state.antiFakeUrl
        }, null, 8, ["src"]),
        _hoisted_159
      ]),
      _hoisted_160
    ], 512), [
      [_vShow, _ctx.state.antiFakeUrl && _ctx.state.isShowAntiFake]
    ])
  ]))
})